<template>
  <div class="d-flex" :style="element.style">
    <b-img-lazy v-bind="mainProps" :src="getImageUrl(element.src)"></b-img-lazy>
  </div>
</template>

<script>
import {ENTRYPOINT} from '../../../config/entrypoint'
export default {
  props: {
    element: {
      type: Object,
      required: true
    },
    center: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    element: {
      handler (value) {
        if (value != null) {
          if (value.dimension.w < 150 || value.dimension.h < 150) {
            this.mainProps.width = value.dimension.w
            this.mainProps.height = value.dimension.h
          }
        }
      },
      deep: true
    }
  },
  data () {
    return {
      mainProps: {
        width: 150,
        height: 150,
        blank: true,
        fluid: true,
        blankColor: '#bbb',
        class: 'm-1',
        center: false
      }
    }
  },
  created () {
    if (this.element.size) {
      this.mainProps.width = this.element.size.w
      this.mainProps.height = this.element.size.h
    }
    this.mainProps.center = this.center
  },
  methods: {
    getImageUrl (src) {
      if (src.startsWith('upload')) {
        return `${ENTRYPOINT}/${src}`
      }
      return src
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/display/logoElement.vue